import { Component, ViewEncapsulation } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { HttpErrorResponse } from '@angular/common/http'
import { ToastrService } from 'ngx-toastr'
import { AuthenticationService } from '../../../../modules/auth/core/services/authentication.service'

type ModalStep = 'code' | 'backup'

@Component({
	selector: 'app-backup-codes-modal',
	templateUrl: './backup-codes-modal.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class BackupCodesModalComponent {
	public step: ModalStep = 'code'
	public isLoading: boolean = false
	public form: FormGroup
	public backupCodes: string[] = []
	public copied: boolean = false

	constructor(
		public activeModal: NgbActiveModal,
		private _formBuilder: FormBuilder,
		private _toastrService: ToastrService,
		private _authenticationService: AuthenticationService,
	) {
		this.form = this._formBuilder.group({
			code: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
		})
	}

	public onSubmit(): void {
		this.isLoading = true
		this._authenticationService
			.regenerateBackupCodes(this.form.value.code)
			.subscribe(
				(response: { backup_codes: string[] }): void => {
					this.backupCodes = response.backup_codes
					this.step = 'backup'
					this.isLoading = false
				},
				(error: HttpErrorResponse): void => {
					this._toastrService.error(error?.error?.message || 'Неверный код')
					this.isLoading = false
				},
			)
	}

	public copyBackupCodes(): void {
		const text: string = this.backupCodes.join('\n')
		navigator.clipboard.writeText(text).then((): void => {
			this.copied = true
			setTimeout((): void => { this.copied = false }, 2000)
		})
	}
}
